"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GET_PRODUCT_TREE_NODE_AGGREGATION_STATUS = void 0;
const gql_1 = require("../../../../__generated__/gql");
exports.GET_PRODUCT_TREE_NODE_AGGREGATION_STATUS = (0, gql_1.gql)(`
  query NodeAggregationStatus($catalog: ID!, $productTreeNodeId: ID!) {
    productTreeNode(id: $productTreeNodeId) {
      productAggregatedLabelsNew(catalog: $catalog) {
        pendingCounts
      }
    }
  }
`);
